import React, { useCallback, useEffect, useState } from "react";
import SomaStatus from "../../../components/SomaStandard/SomaStatus";
import CadastroBloqueado from "../Components/CadastroBloqueado";
import FormSomaPlaceCadastro from "../Components/FormSomaPlace";
import useSomaPlaceUser from "../../../Hooks/SomaPlaceContext";
import Modal from "../../../components/Modal";
import Contrato from "../Components/Contrato";
import SomaPlaceService from "../../../Services/SomaPlace/index";
import { Button, Grid } from "@material-ui/core";
import { parseCNPJ, parsePhoneNumber, parseCPF } from "../util/parsers";

const Cadastro = (props) => {
  let { somaPlaceUser,setSomaPlaceUser, status, updateSomaPlaceUser, signature, latestContract } = useSomaPlaceUser();

  let [edit,setEdit] = useState(undefined);

  useEffect(()=>{
    setSomaPlaceUser(null);
  },[setSomaPlaceUser])
  const pageStatus = status ? "result" : "wait";
  const [showContrato, setShowContrato] = useState(false);
  const [showInfo, setShowInfo] = useState(false);

  const checkUserIsValid = (user) => {
    let paramsToCheck = [
      "id",
      "clifor",
      "corporateName",
      "street",
      "complement",
      "number",
      "district",
      "representativeEmail",
      "representativeName",
      "representativeDocumentNumber",
      "city",
      "state",
      "zipCode",
      "representativeName",
      "professionalQualification",
      "cnpj",
      "tradeName",
      "bankData",
    ];
    for (let p of paramsToCheck) {
      if (user[p] == null) {
        setShowInfo(true);
        return false;
      }
    }
    let bankData = user.bankData;
    let paramsBankToCheck = [
      "id",
      "userId",
      "bankNumber",
      "accountNumber",
      "accountType",
      "agencyNumber",
      "accountDigit",
    ];
    for (let p of paramsBankToCheck) {
      if (bankData[p] == null) {
        setShowInfo(true);
        return false;
      }
    }
    return true;
  };

  useEffect(() => {
    if (status && status === 200 && somaPlaceUser) {
      if ((!signature || signature.contractId !== latestContract.id) && checkUserIsValid(somaPlaceUser)) {
        setShowContrato(true);
      }
    }
  }, [latestContract, signature, somaPlaceUser, status]);

  const closeModal = useCallback(() => {
    setShowContrato(false);
    updateSomaPlaceUser();
  }, [setShowContrato, updateSomaPlaceUser]);

  useEffect(()=>{
    let editVal =  somaPlaceUser
    ? {
        id: somaPlaceUser.id,
        clifor: somaPlaceUser.clifor,
        corporateName: somaPlaceUser.corporateName,
        street: somaPlaceUser.street,
        complement: somaPlaceUser.complement,
        primaryPhone: parsePhoneNumber(somaPlaceUser.primaryPhone),
        number: somaPlaceUser.number,
        district: somaPlaceUser.district,
        representativeEmail: somaPlaceUser.representativeEmail,
        representativeDocumentNumber: parseCPF(somaPlaceUser.representativeDocumentNumber),
        city: somaPlaceUser.city,
        state: somaPlaceUser.state,
        zipCode: somaPlaceUser.zipCode,
        representativeName: somaPlaceUser.representativeName,
        professionalQualification: somaPlaceUser.professionalQualification,
        cnpj: parseCNPJ(somaPlaceUser.cnpj),
        stateRegistration: somaPlaceUser.stateRegistration,
        tradeName: somaPlaceUser.tradeName,
        bankId: somaPlaceUser.bankData?.id,
        bankUserId: somaPlaceUser.bankData?.userId,
        bankNumber: somaPlaceUser.bankData?.bankNumber,
        accountNumber: somaPlaceUser.bankData?.accountNumber,
        agencyNumber: somaPlaceUser.bankData?.agencyNumber,
        accountType: somaPlaceUser.bankData?.accountType,
        accountDigit: somaPlaceUser.bankData?.accountDigit,
      }
    : undefined;

    setEdit({...editVal})

  }, [somaPlaceUser])


  return (
    <>
      <SomaStatus status={pageStatus}>
        {!status?.bloqueio && edit ? (
          <FormSomaPlaceCadastro setSomaPlaceUser={updateSomaPlaceUser} edit={edit} />
        ) : (
          <CadastroBloqueado />
        )}
      </SomaStatus>
      <Modal open={showContrato} modalName={"Contrato"} hideButtons onClose={closeModal}>
        <Contrato
          aceito={async (contrato) => {
            await SomaPlaceService.SomaPlace.contractSignature({ contractId: latestContract.id });
            closeModal();
          }}
          onCancel={closeModal}
        />
      </Modal>
      <Modal open={showInfo} modalName={"Informações necessárias"} hideButtons onClose={closeModal}>
        <Grid item style={{ margin: "20px" }}>
          <div>Preencha todas as informações para concluir o cadastro.</div>
        </Grid>
        <Grid item style={{ margin: "20px", display: "flex", justifyContent: "flex-end" }}>
          <Button
            onClick={() => setShowInfo(false)}
            color={"primary"}
            variant={"contained"}
            style={{ color: "white", fontWeight: 600 }}
          >
            Continuar
          </Button>
        </Grid>
      </Modal>
    </>
  );
};

export default Cadastro;
